var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLedger = function SvgLedger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 128,
    viewBox: "0 0 146 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.262 119.94V127.998H145.57V91.6548H137.511V119.94H90.262ZM90.262 0V8.05844H137.511V36.3452H145.57V0H90.262ZM63.4464 36.3452H55.3879V91.6529H91.7332V84.3842H63.4464V36.3452ZM0 91.6548V128H55.3076V119.94H8.05844V91.6548H0ZM0 0V36.3452H8.05844V8.05844H55.3076V0H0Z",
    fill: "currentColor"
  })));
};

export { SvgLedger as ReactComponent };
export default __webpack_public_path__ + "d10d3d13d22b32be9fdfada54d5e37d4.svg";